module.exports = __webpack_public_path__ + "static/media/3DPPA15.c76fd413.jpg";